import { render } from "./Container.vue?vue&type=template&id=785bacae&scoped=true"
const script = {}

import "./Container.vue?vue&type=style&index=0&id=785bacae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-785bacae"

export default script